// extracted by mini-css-extract-plugin
export default {"main":"daba51042b","tit":"d9337cf365","maintitle":"_6c42b586b8","ylw":"_6cb2d7b023","white":"_8896f03fb8","mv_title":"c4e7f53f2e","mv_nc":"_56c8c91bd4","mv_in":"_3916ef63a7"};